import { showOkCancel } from "../../../../../shared/react/msgbox";
import { createMap, isArrayEmpty } from "../../../../../shared/utils/array";
import { GenericProps, User, UserUpdate } from "../types";
import { getUserUpdates } from "../users";

interface Props extends GenericProps {
    close: (result?: any) => void
}

export function DialogFooter({ state, dispatch, close }: Props) {

    const { users, updated, api, loggedInUser: { ownerRole }, cropping: { cropping } } = state

    const cancel = () => dispatch({ type: "cancelChanges" })

    const refresh = async () => {
        const data = await api.fetchApiData()
        dispatch({ type: "load", payload: data })
    }

    const updateUsers = async () => {

        const updates = getUserUpdates(users.edits, cropping)

        if (!await confirmDeletions(updates, users.users)) {
            return
        }

        await api.updateUsers(updates)

    }

    const switchToRestrictedMember = async () => {

        if (!await confirmSwitchToRestrictedMember()) {
            return
        }

        await api.switchToRestrictedMember()

    }

    const save = async () => {

        // If the current user is not an owner,
        // then the only change that can be saved
        // is a request to switch their own role to "restricted member"

        if (ownerRole) {
            await updateUsers()
        }
        else {
            await switchToRestrictedMember()
        }

        const payload = await api.fetchApiData()

        dispatch({ type: "load", payload })

    }

    return <>

        {
            (ownerRole) && (!updated) &&
            <button type="button" className="btn btn-link" onClick={refresh}>
                <i className="fa-solid fa-rotate-right" />
                &nbsp;Refresh
            </button>

        }

        {
            (!updated) &&
            <button type="button" className="btn btn-primary" onClick={close}>
                Close
            </button>
        }

        {
            updated &&
            <>

                <button type="button" className="btn btn-warning" onClick={cancel}>
                    Cancel
                </button>

                <button type="button" className="btn btn-success" onClick={save}>
                    Save
                </button>

            </>
        }

    </>

}

function confirmDeletions(updates: UserUpdate[], users: User[]) {

    const deletions = updates.filter(u => u.delete)

    if (isArrayEmpty(deletions)) {
        return <tr></tr>
    }

    const usersMap = createMap(users, u => u.userId)

    return showOkCancel(<>
        <p>
            <i className="fas fa-exclamation-triangle text-danger" />&nbsp;
            This will revoke access to this holding from for the following users:
            <ul style={{ margin: "1rem 0" }}>
                {
                    deletions.map(d => <li key={d.userId}>
                        &ndash; {usersMap.get(d.userId).displayName}
                    </li>)
                }
            </ul>
        </p>
        <p>
            Please note that this operation is irreversible. If you need to grant access again later, you will have to send a new invitation.
        </p>
    </>)
}


function confirmSwitchToRestrictedMember() {

    return showOkCancel(<>
        <p>You have changed your role to 'Restricted member'.</p>
        <p>Omnia will be restarted for the changes to take effect.</p>
        <p>Please note that once done, you will not be able to revert this change yourself. Only a holding owner, or an Omnia admin, will be able to do so.</p>
    </>,
        "Change to restricted member"
    )

}